module.exports = __webpack_public_path__ + "static/media/rhododendron.927a66bd.bmp";